export default "__VITE_ASSET__D$cksfJJ__"